import { Box, Button, FormControl, FormControlLabel, Grid, Grid2, IconButton, MenuItem, Paper, Radio, RadioGroup, Select, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography } from "@mui/material";
import Navbar from "../navbar/Navbar";
import Sidemenu from "../sidemenu/Sidemenu";
import { useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { Label } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import TokenError from "../tokenError";
import dayjs, { utc } from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import timezone from 'dayjs/plugin/timezone';
import { useRef } from "react";
var constants = require('../../constant');

dayjs.extend(utc);

const Promotions = () => {
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [statusFilter, setStatusFilter] = useState('');
    const [open, setOpen] = useState(false);
    const [editable, setEditable] = useState(false);

    const [rows, setRows] = useState([]);
    const [promoId, setPromoId] = useState(0);
    const [title, setTitle] = useState('');
    const [promoType, setPromoType] = useState(1);
    const [discountValue, setDiscountValue] = useState('');
    const [discountPercentage, setDiscountPercentage] = useState("");
    const [maximumDiscount, setMaximumDiscount] = useState("");
    const [maximumAllowed, setMaximumAllowed] = useState("");
    const [endDate, setEndDate] = useState(dayjs());
    const [startDate, setStartDate] = useState(dayjs());
    const [perUserLimit, setPerUserLimit] = useState("");
    const [perDayLimit, setPerDayLimit] = useState("");
    const [allowedVehicleType, setAllowedVehicleType] = useState("");
    const [promoStatus, setPromoStatus] = useState(1);
    const [vehicleClient, setVehicleClient] = useState('');
    const [promoCode, setPromoCode] = useState('');
    const [visibilityFilter, setVisibilityFilter] = useState(1);
    const [tnc, setTnc] = useState("");
    // const [corpStatus, setCorpStatus] = useState('Active');
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const user_specific_promo_enabled = localStorage.getItem('user_specific_promo_enabled') || 0;

    //paging
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('vehicleName');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const navigate = useNavigate();

    const rowArray = Array.isArray(rows) ? rows : [];
    const totalEntries = rowArray.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const [partnerId, setPartnerId] = useState('');
    const [partnerList, setPartnerList] = useState([]);
    const [userIdSearch, setUserIdSearch] = useState('');
    const [showUserDropdown, setShowUserDropdown] = useState(false);
    const [promoUserIds, setPromoUserIds] = useState([]);
    const [customerData, setCustomerData] = useState([]);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (!userIdSearch.trim()) {
            setCustomerData([]);
            return;
        }
        const debounceTimer = setTimeout(() => {
            fetchData();
        }, 300);
        return () => clearTimeout(debounceTimer);
    }, [userIdSearch]);

    // Add outside-click handler
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowUserDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    //sorting
    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleFilterChange = (filterType, value) => {
        if (filterType === 'city') setCityFilter(value);
        if (filterType === 'status') setStatusFilter(value);
    };

    const handleOpenAddCorporate = () => {
        setOpen(true);
        setEditable(false);
        setTitle('');
        setPromoType(1);
        setAllowedVehicleType('');
        setDiscountPercentage('');
        setDiscountValue('');
        setMaximumDiscount('');
        setMaximumAllowed('');
        setEndDate(dayjs());
        setStartDate(dayjs());
        setPerUserLimit('');
        setPerDayLimit('');
        setPromoCode('');
        setPromoStatus(1);
        setTnc('');
        setPromoId(0);
        setPromoUserIds([]);
        setUserIdSearch('');
        setCustomerData([]);
        setPartnerId('');
        setVisibilityFilter(1);
    }

    const handleOpenEditCorporate = (row) => {
        setTitle(row.title);
        setPromoType(row.promo_type);
        setAllowedVehicleType(row.allowed_vehicle_type);
        setDiscountPercentage(row.discount_percentage);
        setDiscountValue(row.discount_values);
        setMaximumDiscount(row.maximum_discount);
        setMaximumAllowed(row.maximum_allowed);
        setEndDate(dayjs(row.end_date).utc());
        setStartDate(dayjs(row.start_date).utc());
        setPerUserLimit(row.per_user_limit);
        setPerDayLimit(row.per_day_limit);
        setPromoCode(row.promo_code);
        setPromoStatus(row.is_active);
        setPromoId(row.id);
        setTnc(row.terms_and_conds);
        setOpen(true);
        setEditable(true);
        if(Number(user_specific_promo_enabled)==1) setPromoUserIds((row.user_ids)?.split(','));
        if(Number(user_specific_promo_enabled)==1) setPartnerId(row.partner_id);
        if(Number(user_specific_promo_enabled)==1) setVisibilityFilter(row.is_visible);
        setUserIdSearch('');
    }

    const handleClose = () => {
        setOpen(false);
        setEditable(false);
    }

    const fetchPromoData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/panel/fetch_city_promotions';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchVehicleClient();
    },[cityFilter])

    useEffect(() => {
        fetchPromoData();
    }, [cityFilter]);

    const handleSubmit = async() =>{
        console.log('userids', promoUserIds);
        console.log('perDayLimit = ', perDayLimit)
        const token = localStorage.getItem('token');
        if(title===""){
            setMessage('Title is required.');
            showSnackbar(true);
            return;
        }
        if(promoCode===""){
            setMessage('Promo Code is required.');
            showSnackbar(true);
            return;
        }
        if(perDayLimit===""){
            setMessage('Per Day Limit is required.');
            showSnackbar(true);
            return;
        }
        if(perUserLimit===""){
            setMessage('Per User Limit is required.');
            showSnackbar(true);
            return;
        }
        if(maximumAllowed===""){
            setMessage('Maximum Allowed is required.');
            showSnackbar(true);
            return;
        }
        if(maximumDiscount===""){
            setMessage('Maximum Discount is required.');
            showSnackbar(true);
            return;
        }
        if(promoType==1 && discountPercentage===""){
            setMessage('Discount Percentage is required');
            showSnackbar(true);
            return;
        }
        if(promoType==2 && discountValue===""){
            setMessage('Discount value is required.');
            showSnackbar(true);
            return;
        }
        const payload = {
            token: token,
            city_id: cityFilter,
            title: title,
            promo_type: promoType,
            // discount_values: discountValue,
            maximum_discount:maximumDiscount,
            start_date: startDate.format("YYYY-MM-DD"),
            end_date: endDate.format("YYYY-MM-DD"),
            maximum_allowed: maximumAllowed,
            per_day_limit: perDayLimit,
            per_user_limit: perUserLimit,
            allowed_vehicle_type: allowedVehicleType,
            terms_and_conds: tnc,
            is_active: promoStatus,
            promo_code: promoCode
        };
        if(editable && promoId!=0){
            payload.id = promoId;
        }

        if(promoType==1){  //percentage
            payload.discount_values = -1
        }
        else{
            payload.discount_values = discountValue
        }

        if(promoType==2){  //Flat
            payload.discount_percentage = -1
        }else{
            payload.discount_percentage = discountPercentage
        }

        if(Number(user_specific_promo_enabled)==1){
            payload.user_ids = promoUserIds?.join(',');
        }

        if(Number(user_specific_promo_enabled)==1){
            payload.partner_id = partnerId;
        }

        if(Number(user_specific_promo_enabled)==1){
            payload.is_visible = visibilityFilter==true ? 1 : 0;
        }

        try {
            const url = operationsUrl + '/panel/add_update_promotions';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                handleClose(); // Close the modal after saving
                fetchPromoData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            setMessage(error);
        }
    }

    const fetchVehicleClient = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/vehicle/get_client_vehicles';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // Filter active vehicles
                const activeVehicles = response.data.filter(vehicle => vehicle.is_active === 1);
                // console.log('response.data[0] = ', activeVehicles[0].vehicle_type)
                setVehicleClient(activeVehicles);
                setAllowedVehicleType(response.data[0].vehicle_type)
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const fetchData = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            const url = `${serverUrl}/customer/fetch_all`;
            const obj = {
                token,
                timestamp,
                ...(cityFilter && { city_id: cityFilter }),
                ...(userIdSearch && { phone_number: userIdSearch }),
            };
            const response = await makeGetRequestToUrl(url, obj);
            if (response.flag == 102) {
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => navigate('/signup'), 2000);
            }
            if (response.flag === 200) {
                setCustomerData(response.data);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const toggleUserSelection = (userId) => {
        const id = String(userId);
        setPromoUserIds(prev =>
            prev?.includes(id)
                ? prev.filter(x => x !== id)
                : [...(prev || []), id]
        );
    };

    const fetchPartnersList = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/panel/fetch_partners_promotions';
            const timestamp = new Date().getTime();
            const body = {
                token: token
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const activeVehicles = response.data.filter(item => item.is_active === 1);
                setPartnerList(activeVehicles);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        fetchPartnersList();
    },[])

    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Promotions
            </Typography>

            {/* Filters */}
            <Grid2 item container spacing={2} alignItems="center" sx={{ marginTop: '2%', marginBottom: '2%' }}>
                <Grid2 item>
                    <Select
                        value={cityFilter}
                        onChange={(e) => handleFilterChange('city', e.target.value)}
                        displayEmpty
                        style={{
                            width: '220px',
                            height: '50px',
                            borderRadius: '8px',
                            backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_id} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                

                <Grid2 item>
                    <Select
                        value={statusFilter}
                        onChange={(e) => handleFilterChange('status', e.target.value)} displayEmpty
                        style={{width: '220px', height: '50px', borderRadius: '8px', backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Status</MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained" onClick={handleOpenAddCorporate}
                        style={{width:'185px',height: '50px',backgroundColor:'#000000',textTransform:'none',borderRadius:'8px'}}>
                        + Add Promotions
                    </Button>
                </Grid2>
            </Grid2>

            {/* add - edit modal */}
            {open && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>

                                <Typography variant="h6" style={{ marginBottom: '24px', marginTop: '8px', fontWeight: 'bold' }}>
                                    {editable ? 'Edit Promo' : 'Add Promo'}
                                </Typography>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Label>Title<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Title" fullWidth variant="outlined" type="text" value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Promo Type<span style={{ color: 'red' }}>*</span></Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={promoType} fullWidth
                                            onChange={(e) => setPromoType( e.target.value)}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                                            <MenuItem value="1">Percentage</MenuItem>
                                            <MenuItem value="2">Flat</MenuItem>
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Start Date<span style={{ color: 'red' }}>*</span></Label>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                                <DatePicker sx={{height:'50px'}}
                                                value={startDate} minDate={dayjs()}
                                                onChange={(newValue) => setStartDate(newValue)}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                        
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>End Date<span style={{ color: 'red' }}>*</span></Label>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                                <DatePicker sx={{height:'50px'}}
                                                // label="Start Date"
                                                value={endDate} minDate={startDate}
                                                onChange={(newValue) => {
                                                    if (newValue && dayjs(newValue).isBefore(startDate)) {
                                                        alert("End Date cannot be earlier than Start Date"); // Display an alert or handle error
                                                    } else {
                                                        setEndDate(newValue); // Update state if valid
                                                    }
                                                }}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </Grid>

                                    {promoType==2 && (
                                        <Grid item xs={12} sm={6}>
                                            <Label>Discount Value<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Discount Value" fullWidth variant="outlined" type="number" value={discountValue}
                                                onChange={(e) => setDiscountValue(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid>
                                    )}

                                    {promoType==1 && (
                                        <Grid item xs={12} sm={6}>
                                            <Label>Discount Percentage<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Discount Percentage" fullWidth variant="outlined" type="number" value={discountPercentage}
                                                onChange={(e) => setDiscountPercentage(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid>
                                    )}
                                    

                                    <Grid item xs={12} sm={6}>
                                        <Label>Maximum Discount<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Maximum Discount" fullWidth variant="outlined" type="number" value={maximumDiscount}
                                            onChange={(e) => setMaximumDiscount(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Maximum Allowed<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Maximum Allowed" fullWidth variant="outlined" type="number" value={maximumAllowed}
                                            onChange={(e) => setMaximumAllowed(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Per User Limit<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Per User Limit" fullWidth variant="outlined" type="number" value={perUserLimit}
                                            onChange={(e) => setPerUserLimit(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Per Day Limit (per user)<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Per Day Limit" fullWidth variant="outlined" type="number" value={perDayLimit}
                                            onChange={(e) => setPerDayLimit(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>


                                    <Grid item xs={12} sm={6}>
                                        <Label>Allowed Vehicle Type<span style={{ color: 'red' }}>*</span></Label>
                                        {/* <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Allowed Vehicle Type" fullWidth variant="outlined" type="text" value={allowedVehicleType}
                                            onChange={(e) => setAllowedVehicleType(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        /> */}
                                        <Select sx={{marginTop:'2%'}} fullWidth
                                            value={allowedVehicleType} 
                                            onChange={(e) => setAllowedVehicleType( e.target.value)}
                                            style={{ height: '50px', borderRadius: '8px'}}>
                                            {/* <MenuItem value="">Vehicle</MenuItem> */}
                                            {vehicleClient.map((vehicle) => (
                                                <MenuItem key={vehicle.vehicle_type} value={vehicle.vehicle_type}>
                                                    {vehicle.vehicle_name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Status<span style={{ color: 'red' }}>*</span></Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={promoStatus} fullWidth
                                            onChange={(e) => setPromoStatus( e.target.value)}
                                            style={{ height: '50px', borderRadius: '4px', backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                                            {/* <MenuItem value="">Status</MenuItem> */}
                                            <MenuItem value="1">Active</MenuItem>
                                            <MenuItem value="0">Inactive</MenuItem>
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Promo Code<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Promo Code" fullWidth variant="outlined" type="text" value={promoCode}
                                            onChange={(e) => {
                                                const value = e.target.value.slice(0, 15);
                                                setPromoCode(value);
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    {(Number(user_specific_promo_enabled)==1) && 
                                        <Grid item xs={12} sm={12}>
                                            <Label>User IDs</Label>
                                            <div ref={dropdownRef} style={{ position: 'relative', marginTop: '1%' }}>

                                                {/* Selected user chips */}
                                                {promoUserIds?.length > 0 && (
                                                    <div style={{
                                                        display: 'flex', flexWrap: 'wrap', gap: '6px',
                                                        marginBottom: '8px'
                                                    }}>
                                                        {promoUserIds.map(user => (
                                                            <div key={user} style={{
                                                                display: 'flex', alignItems: 'center', gap: '4px',
                                                                backgroundColor: '#E8F0FE', color: '#1a73e8',
                                                                padding: '4px 10px', borderRadius: '16px',
                                                                fontSize: '13px', fontWeight: 500
                                                            }}>
                                                                {user}
                                                                <span
                                                                    onClick={() => toggleUserSelection(user)}
                                                                    style={{ cursor: 'pointer', fontWeight: 700, marginLeft: '4px', lineHeight: 1 }}>
                                                                    ×
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {/* Search input */}
                                                <TextField type="number"
                                                    placeholder="Search users by phone number..."
                                                    fullWidth
                                                    variant="outlined"
                                                    value={userIdSearch}
                                                    onChange={(e) => {
                                                        setUserIdSearch(e.target.value);
                                                        setShowUserDropdown(true);
                                                    }}
                                                    onFocus={() => userIdSearch && setShowUserDropdown(true)}
                                                    InputProps={{
                                                        style: {
                                                            height: '50px', fontSize: '16px',
                                                            padding: '8px 14px', backgroundColor: '#FFFFFF'
                                                        }
                                                    }}
                                                />

                                                {/* Dropdown */}
                                                {showUserDropdown && (
                                                    <div style={{
                                                        position: 'absolute', top: '100%', left: 0, right: 0,
                                                        backgroundColor: '#FFFFFF', border: '1px solid #E0E0E0',
                                                        borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
                                                        zIndex: 1200, maxHeight: '220px', overflowY: 'auto', marginTop: '4px'
                                                    }}>
                                                        {customerData.length === 0 ? (
                                                            <div style={{ padding: '12px 16px', color: '#888', fontSize: '14px' }}>
                                                                {userIdSearch ? 'No users found' : 'Type to search...'}
                                                            </div>
                                                        ) : (
                                                            customerData.map(user => {
                                                                const isSelected = promoUserIds?.some(id => String(id) === String(user.user_id));
                                                            
                                                                return (
                                                                    <div
                                                                        key={user.user_id}
                                                                        onClick={() => toggleUserSelection(user.user_id)}
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '10px',
                                                                            padding: '10px 16px',
                                                                            cursor: 'pointer',
                                                                            backgroundColor: isSelected ? '#EAF2FF' : '#FFFFFF',
                                                                            borderLeft: isSelected ? '4px solid #0065FF' : '4px solid transparent',
                                                                            borderBottom: '1px solid #F5F5F5',
                                                                            transition: 'all 0.15s'
                                                                        }}
                                                                        onMouseEnter={e => {
                                                                            e.currentTarget.style.backgroundColor = isSelected
                                                                                ? '#E3EFFF'
                                                                                : '#F9F9F9';
                                                                        }}
                                                                        onMouseLeave={e => {
                                                                            e.currentTarget.style.backgroundColor = isSelected
                                                                                ? '#EAF2FF'
                                                                                : '#FFFFFF';
                                                                        }}
                                                                    >
                                                                        {/* Checkbox */}
                                                                        <div
                                                                            style={{
                                                                                width: '18px',
                                                                                height: '18px',
                                                                                borderRadius: '4px',
                                                                                border: `2px solid ${
                                                                                    isSelected ? '#0065FF' : '#BDBDBD'
                                                                                }`,
                                                                                backgroundColor: isSelected ? '#0065FF' : '#FFFFFF',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                flexShrink: 0
                                                                            }}
                                                                        >
                                                                            {isSelected && (
                                                                                <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                                                                                    <path
                                                                                        d="M1 3.5L3.5 6.5L9 1"
                                                                                        stroke="white"
                                                                                        strokeWidth="1.8"
                                                                                        strokeLinecap="round"
                                                                                    />
                                                                                </svg>
                                                                            )}
                                                                        </div>
                                                            
                                                                        <div style={{ flex: 1 }}>
                                                                            <div
                                                                                style={{
                                                                                    fontSize: '14px',
                                                                                    fontWeight: isSelected ? 600 : 500,
                                                                                    color: isSelected ? '#0065FF' : '#212121'
                                                                                }}
                                                                            >
                                                                                {user.user_name || 'Unknown'} ({user.phone_number})
                                                                            </div>
                                                            
                                                                            <div style={{ fontSize: '12px', color: '#757575' }}>
                                                                                ID: {user.user_id}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </Grid>
                                    }

                                    {(Number(user_specific_promo_enabled)==1) && 
                                        <Grid item xs={6} sm={6}>
                                            <Label>Select Partner</Label>
                                            <Select sx={{marginTop:'1%'}} value={partnerId} onChange={(e) => setPartnerId(e.target.value)} fullWidth
                                                style={{ height: '50px', borderRadius: '4px', backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}
                                            >
                                                {partnerList.map((partner) => (
                                                    <MenuItem value={partner.partner_id}>{partner.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </Grid>
                                    }

                                    {(Number(user_specific_promo_enabled)==1) && 
                                        <Grid item xs={6} sm={6}>
                                            <Label> .</Label>
                                            <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'4px', height:'50px', display:'flex', alignItems:'center', mt:'1%', pl:'8%'}}>
                                                Promo Visible
                                                <Switch checked={visibilityFilter} onChange={(e) => setVisibilityFilter(e.target.checked)} sx={{ml:'4%'}} />
                                            </Grid2>
                                        </Grid>
                                    }

                                    <Grid item xs={12} sm={12}>
                                        <Label>Terms and Conditions</Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Terms and Conditions" fullWidth variant="outlined" type="text" value={tnc}
                                            onChange={(e) => setTnc(e.target.value)} multiline minRows={4}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                        {/* <Textarea placeholder="Terms and Conditions"
                                            minRows={2}
                                            maxRows={4}
                                        /> */}
                                    </Grid>
                                </Grid>

                                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'40px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {editable ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleClose}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Paper>

                        </div>
                    </Box>
                </div>
            )}

            <TableContainer className="table-container" sx={{ maxHeight:'70vh' }}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'id'} direction={orderBy === 'id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('id')}>
                                ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'promo_type'} direction={orderBy === 'promo_type' ? order : 'asc'}
                                    onClick={() => handleRequestSort('promo_type')}>
                                Promo Type
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Title</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'discount_values'} direction={orderBy === 'discount_values' ? order : 'asc'}
                                    onClick={() => handleRequestSort('discount_values')}>
                                Discount Values
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'discount_percentage'} direction={orderBy === 'discount_percentage' ? order : 'asc'}
                                    onClick={() => handleRequestSort('discount_percentage')}>
                                Discount Percentage
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'maximum_discount'} direction={orderBy === 'maximum_discount' ? order : 'asc'}
                                    onClick={() => handleRequestSort('maximum_discount')}>
                                Maximum Discount
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Start Date</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>End Date</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'maximum_allowed'} direction={orderBy === 'maximum_allowed' ? order : 'asc'}
                                    onClick={() => handleRequestSort('maximum_allowed')}>
                                Maximum Allowed
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'per_user_limit'} direction={orderBy === 'per_user_limit' ? order : 'asc'}
                                    onClick={() => handleRequestSort('per_user_limit')}>
                                Per User Limit
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'per_day_limit'} direction={orderBy === 'per_day_limit' ? order : 'asc'}
                                    onClick={() => handleRequestSort('per_day_limit')}>
                                Per Day Limit
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Allowed Vehicle Type</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'is_active'} direction={orderBy === 'is_active' ? order : 'asc'}
                                    onClick={() => handleRequestSort('is_active')}>
                                Status
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Promo Code</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Promo Visible</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>User Ids</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Patner Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Terms and Conditions</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.filter((row) => {
                            const isStatusMatch = statusFilter ? (statusFilter === 'Active' ? row.is_active === 1 : row.is_active === 0) : true;
                            return isStatusMatch;
                        })
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => {
                            const vehicleType = vehicleClient.length>0 ? vehicleClient.find(vehicle => vehicle.vehicle_type === row.allowed_vehicle_type) : {};

                            return(
                                <TableRow key={row.id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', fontWeight:'500' }}>{row.promo_type==1 ? 'Percentage' : 'Flat'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.title}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.discount_values}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px' }}>{row.discount_percentage}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px' }}>{row.maximum_discount}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.start_date.split('T')[0]}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.end_date.split('T')[0]}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px' }}>{row.maximum_allowed}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px' }}>{row.per_user_limit}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px' }}>{row.per_day_limit}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{vehicleType?.vehicle_name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px', color: row.is_active === 1 ? '#0DBA78' : '#D14545', fontWeight:'500'  }}>{row.is_active==1 ? 'Active' : 'Inactive'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px' }}>{row.promo_code}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px', color: row.is_visible === 1 ? '#0DBA78' : '#D14545' }}>{row.is_visible ==1 ? 'Yes' : 'No'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px' }}>{row.user_ids ? row.user_ids : '-'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px' }}>{row.partner_name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px' }}>{row.terms_and_conds}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEditCorporate(row)}
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                            }}>
                                            
                                            <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                            </svg>
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>

                {/* pagination */}
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                    <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            
            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    )
}

export default Promotions;